<template>
  <svg width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.99829 4.77344L0.400215 0.273437L5.59637 0.273438L2.99829 4.77344Z" fill="#D9D9D9"/>
  </svg>
</template>
